import axios from 'axios';
import { ToolsModel } from '@/types';

const ToolsApiUrl = 'tools';

export const ToolsService = {
  async getToolsAsync(): Promise<ToolsModel> {
    const response = await axios.get(`${ToolsApiUrl}`);
    return response.data;
  },
  async deleteV3ConnectorCacheSettings(): Promise<ToolsModel> {
    const response = await axios.delete(`${ToolsApiUrl}/deleteV3ConnectorCacheSettings`);
    return response.data;
  }
};
